import { Leader } from '../types'
import React from 'react'

interface LeaderListProps {
  leaders: Leader[] | undefined
}

const SortedLeaders: React.FC<LeaderListProps> = ({ leaders }) => {
  if (!leaders || leaders.length === 0) return <span>-</span>

  return (
    <>
      {leaders
        .slice()
        .sort((a, b) => (b.main ? 1 : -1))
        .map((leader, index) => (
          <span key={leader.id}>
            {leader.main ? (
              <strong>{`${leader.firstName} ${leader.lastName}`}</strong>
            ) : (
              `${leader.firstName} ${leader.lastName}`
            )}
            {index < leaders.length - 1 && ', '}
          </span>
        ))}
    </>
  )
}

export default SortedLeaders